export const createDefaultHyperdxWorker = () =>
  new Worker(new URL('../logger.worker', import.meta.url), {
    type: 'module',
  });
